// extracted by mini-css-extract-plugin
export var box = "Switcher-module--box--6c2f1";
export var box_md = "Switcher-module--box_md--891ce";
export var box_xmd = "Switcher-module--box_xmd--efe15";
export var box_flex = "Switcher-module--box_flex--a197d";
export var box_lg = "Switcher-module--box_lg--8af82";
export var box_sm = "Switcher-module--box_sm--dcd7a";
export var box_outer = "Switcher-module--box_outer--c2e0c";
export var box_whiteBg = "Switcher-module--box_white-bg--134f4";
export var box_noMarginBottom = "Switcher-module--box_no-margin-bottom--3f955";
export var box_noPadding = "Switcher-module--box_no-padding--bfa02";
export var box_outerGray = "Switcher-module--box_outer-gray--cf0fe";
export var box_dark = "Switcher-module--box_dark--756f9";
export var box_zIndex = "Switcher-module--box_z-index--6abb7";
export var box_zIndex6 = "Switcher-module--box_z-index-6--aff60";
export var box_eventsWithLine = "Switcher-module--box_events-with-line--0d508";
export var box_featuresAo = "Switcher-module--box_features-ao--363e2";
export var box_verticalPaddings = "Switcher-module--box_vertical-paddings--1a9dd";
export var clearP = "Switcher-module--clearP--09375";
export var clearP_vc = "Switcher-module--clearP_vc--643bf";
export var container = "Switcher-module--container--9455a";
export var sm = "Switcher-module--sm--4a9b5";
export var label = "Switcher-module--label--597a7";
export var switcher = "Switcher-module--switcher--ac5d6";
export var reverseColors = "Switcher-module--reverseColors--03058";
export var input = "Switcher-module--input--f0684";
export var fadeInAnimation = "Switcher-module--fadeInAnimation--4ac31";
export var placeHolderShimmer = "Switcher-module--placeHolderShimmer--17f36";